module.exports = __webpack_public_path__ + "assets/img/W1-2-F.f1e07c2b.png";